export default {
  authentication: {
    components: {
      forgottenPassword: {
        backButtonText: 'Back'
      },
      login: {
        emailAccount: {
          backButtonText: 'Back'
        }
      },
      registration: {
        contactPreferences: {
          skipButtonText: 'Skip this step'
        },
        createAccount: {
          backButtonText: 'Back'
        }
      }
    },
    hooks: {
      useAccountLogin: {
        error: {
          submissionError: {
            message: 'Your email and/or password are incorrect. Please try again, or select Forgot Password.'
          }
        }
      },
      useAuthPageProps: {
        landing: {
          heading: 'Create an account.',
          title: 'Create an account'
        },
        loginLanding: {
          heading: 'Log in.',
          title: 'Log in'
        },
        loginForm: {
          heading: 'Log in.',
          title: 'Log in'
        },
        loginVerifyAccount: {
          heading: 'Your account is not yet verified.',
          title: 'Verification required'
        },
        createAccount: {
          heading: 'Create an account.',
          title: 'Create an account'
        },
        resetPassword: {
          heading: 'Create a new password.',
          title: 'Create a new password'
        },
        contactPreferences: {
          heading: 'Keep in contact.',
          title: 'Keep in contact'
        },
        forgottenPassword: {
          heading: 'Forgot your password?',
          title: 'Forgot your password?'
        },
        emailSentConfirmation: {
          verifyAccount: {
            heading: 'Let\'s verify your account.',
            title: 'Verify your account'
          },
          resetPassword: {
            heading: 'Check your inbox.',
            title: 'Check your inbox'
          }
        },
        success: {
          "default": {
            heading: 'You\'re all set up and ready to go!',
            title: 'You\'re all set up and ready to go!'
          },
          accountAlreadyVerified: {
            heading: 'Your account is already verified.',
            title: 'Your account is already verified'
          },
          loginAccountVerified: {
            heading: 'Your account is now verified.',
            title: 'Your account is now verified'
          },
          resetPassword: {
            heading: 'Your password has been changed.',
            title: 'Your password has been changed'
          }
        },
        error: {
          "default": {
            heading: 'Create an account.',
            title: 'Something didn\'t go quite right'
          },
          errorWithRetrySignUp: {
            heading: 'Something didn\'t go quite right.',
            title: 'Something didn\'t go quite right'
          },
          errorWithResendEmail: {
            heading: 'Something went wrong at our end.',
            title: 'Something went wrong at our end'
          },
          linkExpiredWithResendEmail: {
            heading: 'Verification link expired.',
            title: 'Verification link expired'
          },
          loginGeneralError: {
            heading: 'Log in.',
            title: 'Something didn\'t go quite right'
          },
          loginVerificationErrorWithResendEmail: {
            heading: 'Something went wrong at our end.',
            title: 'Something went wrong at our end'
          },
          loginVerificationErrorWithRetry: {
            heading: 'Something didn\'t go quite right.',
            title: 'Something didn\'t go quite right'
          },
          loginVerificationLinkExpiredWithResendEmail: {
            heading: 'Verification link expired.',
            title: 'Verification link expired'
          },
          passwordResetTokenExpired: {
            heading: 'Password link expired.',
            title: 'Password link expired'
          }
        }
      },
      useAuthStatusProps: {
        success: {
          login: {
            accountVerified: {
              buttonText: 'Log in',
              heading: 'Success!'
            }
          },
          registration: {
            buttonText: 'Take me back to where I started',
            buttonTextLogin: 'Click here to login',
            heading: 'Success!',
            subheading: 'Logged in as:'
          },
          resetPassword: {
            buttonText: 'Log into your account',
            loggedInButtonText: 'Done',
            contentPartOne: 'You can change your password at any time by going to your',
            contentPartTwo: 'account settings'
          }
        },
        error: {
          login: {
            generalLoginError: {
              heading: 'Something didn\'t go quite right',
              subheading: 'Please try logging in again later',
              buttonText: 'Try again'
            },
            verificationErrorWithResendEmail: {
              buttonText: 'Resend verification email',
              content: 'Sorry about that! Try clicking below to send a new verification email.'
            },
            verificationErrorWithRetry: {
              buttonText: 'Retry',
              content: 'We\'ve encountered an issue while attempting to verify your account. Please try logging in again and we\'ll send you a new verification email. Alternatively, contact support at the address below.'
            },
            verificationLinkExpiredWithResendEmail: {
              buttonText: 'Resend verification email',
              content: 'The link we sent you is no longer valid, we do this to keep your account secure. Click below to send a new verification email.'
            },
            verificationRequired: {
              buttonText: 'Resend verification email',
              content: 'We recently sent you a link to verify your account. This is to keep your account secure. This link may have expired, please click below to send a new link.'
            }
          },
          registration: {
            buttonText: 'Try again',
            heading: 'Something didn\'t go quite right',
            subheading: 'Try creating an account again.'
          },
          resetPassword: {
            withRetry: {
              buttonText: 'Retry',
              content: 'Click below to retry.'
            },
            withResendEmail: {
              buttonText: 'Resend email',
              content: 'Sorry about that! Try clicking below to send a new verification email.'
            },
            tokenExpired: {
              buttonText: 'Resend email',
              content: 'The link we sent you is no longer valid, we do this to keep your account secure. Click below to send a new forgotten password email.'
            }
          }
        }
      },
      useStepperProps: {
        steps: {
          first: 'Sign up',
          second: 'Preferences',
          third: 'Complete'
        }
      }
    },
    toastNotifications: {
      success: {
        genericEmailReSent: 'Email has been re-sent.',
        verificationEmailReSent: 'Verification email has been re-sent.'
      },
      error: {
        verificationEmailFailed: 'Failed to send verification email.'
      }
    }
  },
  myHub: {
    collection: {
      calloutText: 'Save items and create collections with a free account',
      errorMessage: 'Could not load next items. Please try again later.',
      loadNext: 'Load next',
      // v4 plural
      taglineItem_one: 'item',
      taglineItem_few: 'items',
      taglineItem_many: 'items',
      taglineItem_other: 'items',
      // v3 plural
      taglineItem: 'item',
      taglineItem_plural: 'items',
      taglineItem_0: 'item',
      taglineItem_1: 'items',
      taglineItem_2: 'items'
    },
    collections: {
      taglineSaved: 'saved',
      createButtonText: 'Create a new collection',
      loadErrorMessage: 'Could not load next items. Please try again later.',
      loadNext: 'Load next',
      // v4 plural
      tagline_one: 'collection',
      tagline_few: 'collections',
      tagline_many: 'collections',
      tagline_other: 'collections',
      // v3 plural
      tagline: 'collection',
      tagline_plural: 'collections',
      tagline_0: 'collection',
      tagline_1: 'collections',
      tagline_2: 'collections'
    },
    components: {
      savedItem: {
        card: {
          ariaLabel: {
            save: 'Save',
            unsave: 'Unsave'
          }
        }
      },
      searchFilter: {
        ariaLabel: {
          searchButton: 'search'
        },
        filteredResultsHeading: 'Showing results for:',
        sr: {
          // v4 plural
          filteredItemsResults_one: 'result',
          filteredItemsResults_few: 'results',
          filteredItemsResults_many: 'results',
          filteredItemsResults_other: 'results',
          // v3 plural
          filteredItemsResults: 'result',
          filteredItemsResults_plural: 'results',
          filteredItemsResults_0: 'result',
          filteredItemsResults_1: 'results',
          filteredItemsResults_2: 'results'
        }
      }
    },
    overview: {
      createButtonText: 'Create a new collection',
      defaultTitle: 'My Hub',
      ugcButtonLabel: 'View more',
      ugcCreateButtonText: 'Add a recipe'
    },
    ownItems: {
      createButtonText: 'Add a new recipe',
      loadErrorMessage: 'Could not load next items. Please try again later.',
      loadNext: 'Load next',
      tabData: {
        all: 'All',
        published: 'Published',
        unpublished: 'Unpublished'
      },
      tabFilterError: 'There was a problem filtering your recipes. We have returned all recipes instead.'
    },
    savedItems: {
      // v4 plural
      collectionTaglineItem_one: 'item',
      collectionTaglineItem_few: 'items',
      collectionTaglineItem_many: 'items',
      collectionTaglineItem_other: 'items',
      // v3 plural
      collectionTaglineItem: 'item',
      collectionTaglineItem_plural: 'items',
      collectionTaglineItem_0: 'item',
      collectionTaglineItem_1: 'items',
      collectionTaglineItem_2: 'items',
      collectionTaglineSaved: 'saved',
      loadErrorMessage: 'Could not load next items. Please try again later.',
      loadNext: 'Load next'
    }
  },
  nextCore: {
    signIn: {
      errorLineOne: 'Looking for something specific?',
      errorLineTwo: 'Try',
      errorLineThree: 'signing in',
      errorLineFour: 'to see this page.',
      errorLineFive: 'Not signed up for your free account?',
      errorLineSix: 'Join us here'
    }
  },
  postCreator: {
    confirmation: {
      metaTitle: 'Create a Recipe - Thank you',
      newRecipeButtonText: 'New Recipe',
      ownRecipeButtonText: 'Own Recipes'
    },
    create: {
      metaTitle: 'Create a Recipe'
    },
    edit: {
      editFormTitle: 'Edit Recipe',
      metaTitle: 'Edit Recipe'
    },
    recipeDetails: {
      dropDownOptions: {
        hours: 'hours',
        mins: 'mins'
      },
      heading: 'Recipe Details',
      label: {
        cookTime: 'Cook Time (approx.)',
        difficulty: 'Difficulty level',
        extraTime: 'Any Extra Time (Optional)',
        image: 'Image',
        prepTime: 'Prep Time (approx.)',
        servings: 'Servings',
        shortIntro: 'Short Intro (10-15 words)',
        title: 'Recipe Title (keep it short and descriptive)'
      },
      placeholder: {
        extraTime: 'e.g. plus resting',
        makes: 'e.g. 8 Pieces',
        serves: 'e.g. 4',
        shortIntro: 'Tell us about your recipe',
        title: 'e.g. Momma\'s apple pie'
      },
      servingsButton: {
        makes: 'Makes',
        serves: 'Serves'
      },
      skillLevel: {
        dropDownOptions: {
          challenge: 'A challenge',
          defaultText: '(Please select one)',
          easy: 'Easy',
          moreEffort: 'More effort'
        }
      }
    },
    recipeForm: {
      defaultFeedback: {
        error: 'Oops! Something went wrong',
        info: 'Please save your image before submitting'
      },
      links: {
        back: 'Back to my recipes',
        preview: 'Preview',
        saveDraft: 'Save draft'
      }
    },
    recipeIngredients: {
      heading: 'Ingredients',
      information: {
        lineOne: 'Please use metric if possible (we have a handy',
        lineTwo: 'conversion guide',
        lineThree: 'to help)',
        lineFour: 'You can split your ingredients into groups, e.g. sauce, filling etc.'
      },
      ingredient: {
        buttonText: 'Add next ingredient',
        label: 'Ingredient',
        placeholder: '500g chicken thighs, diced'
      },
      ingredientGroup: {
        buttonText: 'Add group heading',
        heading: 'Heading',
        placeholder: 'For the sauce'
      }
    },
    recipeMethodSteps: {
      heading: 'Method',
      method: {
        buttonText: 'Add next step',
        label: 'Step',
        placeholder: 'First, boil the rice'
      }
    },
    statusFeedback: {
      createLinkeText: 'create a new recipe',
      info: {
        approved: 'Your recipe has been approved',
        "default": 'Oops, something went wrong',
        draft: 'Your recipe has not been submitted yet',
        pending: 'Your recipe is awaiting approval',
        rejected: 'Your recipe was not approved'
      },
      submissionChoice: {
        approved: 'view your recipe',
        "default": 'go back to your recipe hub',
        draft: 'continue editing your recipe',
        heading: 'Perhaps you would like to'
      },
      submittedText: 'Your recipe has been submitted for approval and can no longer be updated.'
    },
    submit: {
      formValidation: {
        defaultMessage: 'Please confirm you have read our terms and conditions'
      },
      informationLineOne: 'Please note that you should only upload your own recipes.',
      informationLineTwo: 'For copyright reasons we will not be able to publish any recipes uploaded',
      informationLineThree: 'by our users that were originally written by any other source. You can read our',
      informationLineFour: 'terms and conditions',
      informationLineFive: 'for more information before submitting your recipe.',
      metaTitle: 'Create a Recipe - Terms and Conditions',
      previewButtonText: 'Preview',
      publishButtonText: 'Publish',
      termsLabel: 'Tick to confirm you have read our terms and conditions'
    }
  }
};